// import { StateReducers } from 'state/reducers/types/StateReducers'

import {
  // AdminMainConnectedProps,
  AdminMainMapStateReturnType,
} from './types'

export const AdminMainMapState = (): // state: StateReducers,
// props: AdminMainConnectedProps,
AdminMainMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
